import { render, staticRenderFns } from "./frameworkModule.vue?vue&type=template&id=1caa93ee&scoped=true"
import script from "./frameworkModule.vue?vue&type=script&lang=js"
export * from "./frameworkModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa93ee",
  null
  
)

export default component.exports